export default __webpack_public_path__ + "static/media/ap2.e09ee2ff.png";